// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { useEffect } from 'react';

import type { BffWebSocketClient } from '@/services/bffWebSocket';

type UseHoleRealtimeParams = {
  socket: BffWebSocketClient;
  userToken?: string | null;
  claimClientId?: string | null;
  claimAccessToken?: string | null;
  inviteToken?: string | null;
  allowAnonymous?: boolean;
  setSocketClient: (client: BffWebSocketClient | null) => void;
};

export const useHoleRealtime = ({
  socket,
  userToken,
  claimClientId,
  claimAccessToken,
  inviteToken,
  allowAnonymous,
  setSocketClient,
}: UseHoleRealtimeParams) => {
  useEffect(() => {
    socket.batchUpdate(() => {
      socket.setInviteToken(inviteToken ?? null);
      socket.setClaimClientId(claimClientId ?? null);
      socket.setClaimAccessToken(claimAccessToken ?? null);
      if (userToken) {
        socket.setAuthToken(userToken);
        socket.setAnonymousReadOnly(false);
        return;
      }

      socket.setAnonymousReadOnly(Boolean(allowAnonymous));
      socket.setAuthToken(null);
    });
    setSocketClient(socket);
  }, [allowAnonymous, claimAccessToken, claimClientId, inviteToken, setSocketClient, socket, userToken]);
};
